import { render, staticRenderFns } from "./QuestionsLayout.vue?vue&type=template&id=7a1683ae&"
import script from "./QuestionsLayout.vue?vue&type=script&lang=js&"
export * from "./QuestionsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports